import { Stack, Typography } from '@mui/material';
import { EditConfigsLoader } from './EditListsDisplayConfigs';
import { panelConfigContainer } from './CommonConfig';

export function ListCustomization() {
  return (
    <Stack py='1rem'>
      <Typography variant='body2' color='text.secondary'>
        Here you can customize the type of information displayed. Changes will be applied to all company lists
        across the platform.
      </Typography>
      <section css={panelConfigContainer}>
        <EditConfigsLoader />
      </section>
    </Stack>
  );
}
